export const themeMap: Record<string, string> = {
    autoTheme: 'CLIENT_AUTO_SELECT_THEME',
    light: 'CLIENT_LIGHT_THEME',
    'light-hc': 'CLIENT_LIGHT_HIGH_CONTRAST_THEME',
    'dark-hc': 'CLIENT_DARK_HIGH_CONTRAST_THEME',
    dark: 'CLIENT_DARK_THEME',
};
